module.exports = __webpack_public_path__ + "static/9y-og-image-f16fce605d049e615ecf7972ac9a5b5e.png";